/**
 * 菜单过滤
 * ---------------------------------------------------------------------------
 * 前端路由表是"系统一共有什么"，服务端返回的 menus 是"这个角色能看什么"。
 * 这里负责把两者对上，得到实际要渲染的侧边栏。
 *
 * 菜单 key 的约定：**与路由完整 path 完全一致**（如 /user/list、/system/role）。
 * 后端 role_menus.menu_key 存的就是这个值，所以两边不用维护映射表。
 */

/** 把父路径和子路径拼成完整 path */
export function resolveMenuPath(base, path) {
  if (!path) {
    return base
  }
  if (path.charAt(0) === '/') {
    return path
  }
  const normalizedBase = base.endsWith('/') ? base.slice(0, -1) : base
  return normalizedBase + '/' + path
}

/**
 * 按菜单权限过滤路由，返回可直接交给侧边栏渲染的数组。
 *
 * @param {Array} routes vue-router 的 routes 配置
 * @param {Array} menus  服务端返回的菜单 key 列表；为空/未加载时返回全部
 */
export function filterRoutesByMenus(routes, menus) {
  if (!menus || !menus.length) {
    return routes.filter(route => !route.hidden)
  }

  const allowed = []
  routes.forEach(route => {
    if (route.hidden) {
      return
    }

    // 没有子路由的（理论上不会出现在侧边栏，保险起见也判一次）
    if (!route.children || !route.children.length) {
      if (menus.includes(route.path)) {
        allowed.push(route)
      }
      return
    }

    const children = route.children.filter(child => {
      if (child.hidden) {
        return false
      }
      return menus.includes(resolveMenuPath(route.path, child.path))
    })

    if (children.length) {
      allowed.push(Object.assign({}, route, { children }))
    }
  })

  return allowed
}

/** 判断某个路由 path 当前是否可访问 */
export function canAccess(menus, path) {
  if (!menus || !menus.length) {
    return true
  }
  return menus.includes(path)
}

/** 取第一个可访问的菜单，用于"没有首页权限时该落到哪" */
export function firstAccessibleMenu(menus) {
  if (!menus || !menus.length) {
    return null
  }
  return menus[0]
}
